export const GET_TRANSACTION_SUMMARY_REPORT = `query TransactionSummaryReportQuery(
  $outletIds: [Long]!
  $startDate: String
  $endDate: String
) {
  transactionSummaryReport(
    outletIds: $outletIds
    startDate: $startDate
    endDate: $endDate
  ) {
    netSales
    totalCollected
    numberOfTransactions
  }
}
`;

export const GET_DAILY_TRANSACTION_SUMMARY_REPORT = `query TransactionSummaryReportQuery(
  $outletIds: [Long]!
  $startDate: String
  $endDate: String
) {
  dailyTransactionSummaryReport(
    outletIds: $outletIds
    startDate: $startDate
    endDate: $endDate
  ) {
    date
    totalCollected
  }
}
`;
